import theme from '../../../../lib/theme';
import { InputLabelProps } from './InputLabel';

const {
  colors,
  scale,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({ status }: InputLabelProps) => ({
  container: {
    display: 'inline-block',
    fontFamily: families.primary,
    color: status ? colors[status] : colors.black,
    marginTop: '0 !important',
    marginBottom: `${scale.xxs} !important`,
    fontSize: font.m,
    fontWeight: font.bold,
    lineHeight: font.m,
    letterSpacing: spacings.m,
    transition: `color 150ms ease-in`,
  },

  optional: {
    color: colors.grey,
    marginLeft: scale.xxs,
    fontWeight: font.normal,
    fontSize: font.s,
    fontStyle: 'italic',
  },
});
